import React, { useState, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';

function isExternalFileDrag(e) {
  // Only activate for files dragged from OS, not internal file moves
  return e.dataTransfer.types.includes('Files') && !e.dataTransfer.types.includes('application/x-file-id');
}

export default function UploadZone({ children, onFilesDropped, disabled }) {
  const [dragging, setDragging] = useState(false);
  const dragCounter = React.useRef(0);

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current++;
    if (isExternalFileDrag(e)) {
      setDragging(true);
    }
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current--;
    if (dragCounter.current === 0) {
      setDragging(false);
    }
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragging(false);
      dragCounter.current = 0;

      if (disabled) return;

      // Only handle OS file drops, not internal moves
      if (!e.dataTransfer.types.includes('application/x-file-id')) {
        const files = e.dataTransfer.files;
        if (files?.length > 0 && onFilesDropped) {
          onFilesDropped(files);
        }
      }
    },
    [onFilesDropped, disabled]
  );

  return (
    <Box
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      sx={{ position: 'relative', minHeight: '100%' }}
    >
      {children}

      {/* Full-screen overlay on drag */}
      {dragging && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'rgba(21, 101, 192, 0.12)',
            backdropFilter: 'blur(2px)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            border: '3px dashed',
            borderColor: 'primary.main',
            pointerEvents: 'none',
          }}
        >
          <CloudUpload sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
          <Typography variant="h5" color="primary.main" fontWeight={600}>
            Rilascia per caricare
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            I file verranno caricati nella cartella corrente
          </Typography>
        </Box>
      )}
    </Box>
  );
}
